var exports = {
  "kL": "GroupInvitesModal.module__container___Nk0xdm",
  "CR": "GroupInvitesModal.module__modalRoot___Nk0xdm" + " " + __webpack_require__(545076)["root"] + " " + __webpack_require__(545076)["large"],
  "dc": "GroupInvitesModal.module__spinnerContainer___Nk0xdm",
  "Ye": "GroupInvitesModal.module__errorBox___Nk0xdm",
  "kc": "GroupInvitesModal.module__errorText___Nk0xdm",
  "Zb": "GroupInvitesModal.module__stateBox___Nk0xdm",
  "r9": "GroupInvitesModal.module__stateText___Nk0xdm",
  "Mp": "GroupInvitesModal.module__invitesWrapper___Nk0xdm",
  "$h": "GroupInvitesModal.module__invitesList___Nk0xdm",
  "XG": "GroupInvitesModal.module__scroller___Nk0xdm",
  "eu": "GroupInvitesModal.module__inviteItems___Nk0xdm",
};

module.exports = exports;
